module.exports = __webpack_public_path__ + "img/share.4e1ddbcd.png";